import React, { useEffect, useRef } from 'react';
import './MobileBlockModal.css';

/**
 * Full-screen modal shown on phone / tablet devices when they attempt
 * to start an auction.  Purely informational — the only action is to
 * dismiss and return to the landing page.
 *
 * Props:
 *   isOpen     – boolean, controls visibility
 *   onDismiss  – callback when the user taps the dismiss button
 */
export default function MobileBlockModal({ isOpen, onDismiss }) {
  const dismissRef = useRef(null);

  /* Trap focus on the dismiss button while the modal is visible */
  useEffect(() => {
    if (isOpen && dismissRef.current) {
      dismissRef.current.focus();
    }
  }, [isOpen]);

  /* Lock body scroll while modal is open */
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="mobile-block" role="dialog" aria-modal="true" aria-labelledby="mobile-block-title">
      <div className="mobile-block__backdrop" />

      <div className="mobile-block__card">
        <span className="mobile-block__icon" aria-hidden="true">📱</span>

        <h2 id="mobile-block-title" className="mobile-block__title">
          Not Available on Mobile ...Yet
        </h2>

        <p className="mobile-block__body">
          Fantasy Auctioneer needs access to your microphone and speaker in ways
          that mobile browsers don't support well yet. A native mobile app is in
          the works&nbsp;&mdash; stay tuned!
        </p>

        <p className="mobile-block__hint">
          For now, grab a laptop&nbsp;or&nbsp;PC and head to{' '}
          <strong>myfantasyauctioneer.com</strong> to run your draft.
        </p>

        <button
          ref={dismissRef}
          className="mobile-block__dismiss"
          onClick={onDismiss}
          type="button"
        >
          Got It
        </button>
      </div>
    </div>
  );
}
